import { useState } from "react";
import { FormattedMessage } from "react-intl";
import {
    BeltAlert,
    Button,
    ExclamationCircleIcon,
    Flex,
    IconBtn,
    PasteIcon,
    QuetionCircleIcon,
    Text,
} from "@paguelofacil/pf-components";
import { QRCode } from "react-qrcode-logo";
import { useNavigate } from "react-router-dom";

import useStore from "../../services/store/useStore";
import { STEPS, STEPS_CRYPTO_PAYMENT } from "../../services/utils/Constants";
import { language, languageDefault } from "../../services/utils/Language";
import ImgCryptofacilQr from "../../assets/images/ImgCryptofacilQr.svg";
import { useInitCryptoPayment } from "../../hooks/useInitCryptoPayment";

import { InformationHowPay } from "../InfoHowPay";
import { CardInfoTime } from "../CardInfoTime";
import CoinAndNetworkForm from "../CoinAndNetworkForm";
import TermAndConditionsPayment from "../TermAndConditionsPayment";

import "./styles.scss";

const DetailsPaymentCrypto = ({ isLoading, setCurrentStep, currentStep }) => {
    const navigate = useNavigate();
    const {
        currencySelected,
        networkSelected,
        addressToPay,
        currentStepZinli,
        hideTitleCrypto,
        setCurrentStepZinli,
        setHideTitleCrypto,
        setReceiveData,
    } = useStore(state => state);

    const { cryptoAmount, isLoadingInitCryptoPayment } = useInitCryptoPayment("ZINLI");
    const [isResetClock, setIsResetClock] = useState(false);

    const onResetTimer = () => {
        console.log("onFinishTimer", isResetClock);
        setIsResetClock(!isResetClock);
    };

    const onFinishTimer = () => {
        //manda al paso anterior para empezar el proceso nuevamente (setear mensaje de error para mostrar cintillo de error)
        setCurrentStep({ ...currentStep, ref: STEPS_CRYPTO_PAYMENT.COIN_NETWORK });
        setCurrentStepZinli({ ...currentStepZinli, ref: STEPS.AMOUNT });
        onResetTimer();
    };

    const onConfirmPayment = () => {
        setReceiveData({
            cryptoAmount,
            amountUsd: currentStepZinli?.data?.amount,
            date: new Date(),
            method: "Crypto",
            network: networkSelected.value,
            coin: currencySelected.value,
            address: addressToPay,
        });

        navigate("/cryptofacil/receive");
    };

    const showInfoAboutPayCrypto = () => {
        setHideTitleCrypto(!hideTitleCrypto);
    };

    const canPayCrypto = currencySelected && networkSelected && !isLoadingInitCryptoPayment;

    return hideTitleCrypto ? (
        <InformationHowPay setShowInfoAboutPaymentCrypto={showInfoAboutPayCrypto} />
    ) : (
        <Flex justify="center" gap="1.5rem">
            {/* {error && <Alert message={error} type="error" onClose={onCloseAlert} />} */}

            <CardInfoTime isResetClock={isResetClock} onFinishTimer={onFinishTimer} initialSecondsTimer={600} />
            <Flex align="center" justify="flex-end">
                <Button
                    className="link-how-pay-crypto"
                    size="md"
                    variant="link"
                    handleClick={showInfoAboutPayCrypto}
                    leftIcon={<QuetionCircleIcon color="#378fa2" />}
                    widthAuto
                >
                    <FormattedMessage
                        id={language.how_pay_with_crypto}
                        defaultMessage={languageDefault.how_pay_with_crypto}
                    />
                </Button>
            </Flex>
            <QRCode
                ecLevel="M"
                eyeRadius={10}
                qrStyle="dots"
                logoImage={ImgCryptofacilQr}
                logoWidth={40}
                value={addressToPay ? addressToPay : ""}
                quietZone={20}
            />
            <BeltAlert style={{ justifyContent: "space-between" }} open variant="warning">
                <Text style={{ width: "100%" }} variant="body6" weight="regular">
                    <FormattedMessage
                        id={language.alert_disclaimer_crypto}
                        defaultMessage={languageDefault.alert_disclaimer_crypto}
                    />
                </Text>
            </BeltAlert>
            <CoinAndNetworkForm onResetTimer={onResetTimer} currencyForDefault={currencySelected} />
            <Flex direction="column" gap="0.25rem" align="flex-start" justify="flex-start">
                <label className="input-label">
                    <FormattedMessage id={language.amount} defaultMessage={languageDefault.amount} />
                </label>
                <Flex direction="row" wrap="nowrap" gap="0.25rem">
                    <input
                        className="inputs"
                        value={isLoading || isLoadingInitCryptoPayment || !cryptoAmount ? "Loading..." : cryptoAmount}
                        placeholder={
                            isLoading || isLoadingInitCryptoPayment || !cryptoAmount ? "Loading..." : cryptoAmount
                        }
                        disabled={true}
                        id="input-amount"
                    />
                </Flex>
                <Text className="message-sub" variant="caption" weight="regular">
                    <ExclamationCircleIcon color="#EDB600" size="12" isFullfill />{" "}
                    <FormattedMessage
                        id={language.consider_tax_from_crypto_wallet}
                        defaultMessage={languageDefault.consider_tax_from_crypto_wallet}
                    />{" "}
                </Text>
            </Flex>
            <Flex direction="column" gap="0.25rem" align="flex-start" justify="flex-start">
                <label className="input-label">
                    <FormattedMessage id={language.address} defaultMessage={languageDefault.address} />
                </label>
                <Flex direction="row" wrap="nowrap" gap="0.25rem">
                    <input
                        className="inputs"
                        value={
                            isLoading || isLoadingInitCryptoPayment || !addressToPay ? "Loading..." : `${addressToPay}`
                        }
                        placeholder={
                            isLoading || isLoadingInitCryptoPayment || !addressToPay ? "cargando..." : `${addressToPay}`
                        }
                        disabled={true}
                        id="input-amount"
                    />
                    <IconBtn
                        size="md"
                        variant="neutral"
                        handleClick={() => navigator.clipboard.writeText(isLoading ? "cargando..." : `${addressToPay}`)}
                    >
                        <PasteIcon size="32" />
                    </IconBtn>
                </Flex>
            </Flex>
            <Button
                className="button-primary-cf"
                fullWidth
                size="md"
                variant="primary"
                disabled={!canPayCrypto}
                handleClick={onConfirmPayment}
            >
                <FormattedMessage id={language.confirm_payment} defaultMessage={languageDefault.confirm_payment} />
            </Button>
            <TermAndConditionsPayment />
        </Flex>
    );
};

export default DetailsPaymentCrypto;
